const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");

export const absUrl = (path = "") => `${SITE_URL}${path}`;

export const ORGANIZATION_ID = `${SITE_URL}/#organization`;

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [{ label: "Home", to: "/" }, ...items].map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.label,
    item: absUrl(item.to),
  })),
});

export const serviceSchema = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: absUrl(path),
  provider: { "@id": ORGANIZATION_ID },
  areaServed: { "@type": "Country", name: "India" },
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const articleSchema = ({ title, description, path, datePublished }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  mainEntityOfPage: absUrl(path),
  datePublished,
  dateModified: datePublished,
  inLanguage: "en-IN",
  author: { "@id": ORGANIZATION_ID },
  publisher: { "@id": ORGANIZATION_ID },
});
